import React from 'react';

interface AnAppLogoProps {
  size?: number;
  className?: string;
}

const AnAppLogo: React.FC<AnAppLogoProps> = ({ size = 120, className }) => {
  const scale = size / 120;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Left eye - green */}
      <g transform="translate(35, 28)">
        <ellipse
          cx="10" cy="8"
          rx="12" ry="8"
          stroke="#1DAF51"
          strokeWidth="2.2"
          fill="none"
        />
        {/* Pupil */}
        <circle cx="10" cy="8" r="3.2" fill="#1DAF51" />
        {/* Eyelash lines */}
        <line x1="3" y1="1" x2="1" y2="-2" stroke="#1DAF51" strokeWidth="1.5" strokeLinecap="round" />
        <line x1="10" y1="-1" x2="10" y2="-4" stroke="#1DAF51" strokeWidth="1.5" strokeLinecap="round" />
        <line x1="17" y1="1" x2="19" y2="-2" stroke="#1DAF51" strokeWidth="1.5" strokeLinecap="round" />
      </g>

      {/* Right eye - yellow */}
      <g transform="translate(65, 24)">
        <ellipse
          cx="12" cy="10"
          rx="13" ry="8.5"
          stroke="#F5C518"
          strokeWidth="2.2"
          fill="none"
          transform="rotate(-8, 12, 10)"
        />
        {/* Pupil */}
        <circle cx="12" cy="10" r="3.2" fill="#F5C518" />
        {/* Eyelash lines */}
        <line x1="4" y1="3" x2="2" y2="0" stroke="#F5C518" strokeWidth="1.5" strokeLinecap="round" />
        <line x1="12" y1="0" x2="12" y2="-3" stroke="#F5C518" strokeWidth="1.5" strokeLinecap="round" />
        <line x1="20" y1="3" x2="22" y2="0" stroke="#F5C518" strokeWidth="1.5" strokeLinecap="round" />
      </g>

      {/* "AnApp" text in blue cursive */}
      <text
        x="60"
        y="78"
        textAnchor="middle"
        fontFamily="'Brush Script MT', 'Segoe Script', 'Dancing Script', cursive"
        fontSize="42"
        fontWeight="bold"
        fill="#2B7DE9"
        letterSpacing="-1"
      >
        AnApp
      </text>
    </svg>
  );
};

export default AnAppLogo;
